export default "__VITE_ASSET__2fb90ae5__"